(() => {
  const SOURCE_ATTR = 'data-devui-product-source';

  function sourceCards() {
    const best = document.querySelector('#MainContent[data-template="index"] .ivalo-ed__products--best');
    const cards = best ? Array.from(best.querySelectorAll('.ivalo-ed__product-card')) : [];
    if (cards.length) return cards.slice(0, 4);
    return Array.from(document.querySelectorAll('#MainContent[data-template="index"] .ivalo-ed__products .ivalo-ed__product-card')).slice(0, 4);
  }

  function removeSources() {
    document.querySelectorAll(`[${SOURCE_ATTR}]`).forEach((node) => node.remove());
  }

  function bridgeProductsIntoFeature() {
    const cards = sourceCards();
    if (!cards.length) return;

    document.querySelectorAll('#MainContent[data-template="index"] .devui-home-section--feature').forEach((root) => {
      if (root.querySelector(`[${SOURCE_ATTR}]`)) return;
      const source = document.createElement('div');
      source.setAttribute(SOURCE_ATTR, 'true');
      source.hidden = true;
      cards.forEach((card) => source.appendChild(card.cloneNode(true)));
      root.appendChild(source);
    });
  }

  function resetHotspotsForEditor() {
    document.querySelectorAll('#MainContent[data-template="index"] .ivalo-ed__feature').forEach((feature) => {
      feature.querySelectorAll('.devui-hotspot-points, .devui-hotspot-ui').forEach((node) => node.remove());
      feature.classList.remove('devui-hotspot-showcase');
      delete feature.dataset.devuiHotspotsReady;
    });
  }

  function init() {
    bridgeProductsIntoFeature();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    removeSources();
    resetHotspotsForEditor();
    bridgeProductsIntoFeature();
  });
})();
